import { MenuItem, MenuList, Popover } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { DropdownButton } from "components/common/DropdownButton"
import { useBoolean } from "hooks/useBoolean"
import React, { useRef } from "react"

const useStyles = makeStyles()(
  (theme) => ({
    popover: {
      overflowY: "hidden",
    },
    paper: {
      display: "flex",
      flexDirection: "column",

      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)",
      border: `1.5px solid ${theme.palette.gray.darker}`,
    },
    menuItem: {
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    },
    menuItemSelected: {
      backgroundColor: theme.palette.primary.light,
    },
  })
)

const SORT_OPTIONS = [
  {
    value: "a-z",
    label: "Sort A-Z",
  },
  {
    value: "z-a",
    label: "Sort Z-A",
  },
] as const

type SortByValue = "a-z" | "z-a"

interface SortByDropdownProps {
  popoverId: string
  value: SortByValue
  onChange: (newValue: SortByValue) => void
}

export const SortByDropdown = (props: SortByDropdownProps) => {
  const { popoverId, value, onChange } = props
  const ref = useRef<HTMLButtonElement | null>(null)
  const popoverOpenState = useBoolean(false)
  const { classes, cx } = useStyles()

  const handleChange = (newValue: SortByValue) => () => {
    popoverOpenState.off()
    onChange(newValue)
  }

  return (
    <>
      <DropdownButton
        isOpen={popoverOpenState.value}
        onClick={popoverOpenState.toggle}
        ref={ref}
        ariaControls={popoverId}>
        Sort By
      </DropdownButton>
      <Popover
        id={popoverId}
        aria-hidden={popoverOpenState.value ? "true" : "false"}
        open={popoverOpenState.value}
        anchorEl={ref.current}
        onClose={popoverOpenState.off}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        classes={{
          root: classes.popover,
          paper: classes.paper,
        }}>
        <MenuList dense>
          {SORT_OPTIONS.map((sortOption) => (
            <MenuItem
              className={cx(
                classes.menuItem,
                sortOption.value === value && classes.menuItemSelected,
              )}
              key={`${sortOption.value}`}
              onClick={handleChange(sortOption.value)}>
              {sortOption.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  )
}
